module.exports = __webpack_public_path__ + "static/other/outro_scene.ae422d52.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/outro_scene.json
// module id = 40
// module chunks = 0